/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Seo_TitleInputs */

const vi_shop_seo_title = /** @type {(inputs: Shop_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề SEO`)
};

/**

* @param {Shop_Seo_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_seo_title = /** @type {((inputs?: Shop_Seo_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Seo_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_seo_title(inputs)
});